/* Krotos – Fraktskydd i varukorgen, sidokorgen och "lagt i varukorgen"-rutan */
(function () {
  if (window.krFraktskydd) return;
  window.krFraktskydd = true;

  var HANDLE = 'fraktskydd';
  var SOURCE = 'kr-fraktskydd';

  /* Dawn deklarerar PUB_SUB_EVENTS som const, så den finns inte på window */
  function events() {
    try { return typeof PUB_SUB_EVENTS !== 'undefined' ? PUB_SUB_EVENTS : null; } catch (e) { return null; }
  }

  function onCartPage() { return !!document.getElementById('main-cart-items'); }
  function drawerEl() { return document.querySelector('cart-drawer'); }
  function slotEl() { return document.querySelector('[data-kr-fs-slot]'); }
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }

  function updateUrl() {
    return ((window.routes && window.routes.cart_update_url) || '/cart/update') + '.js';
  }

  function sectionHTML(html, selector) {
    if (!html) return null;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function setInner(id, html) {
    var el = document.getElementById(id);
    if (el && html !== null) el.innerHTML = html;
  }

  /* Sidokorg (cart drawer) */
  function renderDrawer(state) {
    var drawer = drawerEl();
    if (!drawer || !state.sections) return;
    setInner('CartDrawer', sectionHTML(state.sections['cart-drawer'], '#CartDrawer'));
    setInner('cart-icon-bubble', sectionHTML(state.sections['cart-icon-bubble'], '.shopify-section'));
    drawer.classList.toggle('is-empty', state.item_count === 0);
    var overlay = document.getElementById('CartDrawer-Overlay');
    if (overlay && typeof drawer.close === 'function') overlay.addEventListener('click', function () { drawer.close(); });
  }

  /* "Lagt i varukorgen"-rutan (cart notification) */
  function renderNotice(state) {
    if (!state.sections) return;
    var slot = slotEl();
    var html = sectionHTML(state.sections['kr-fraktskydd'], '.shopify-section');
    if (slot && html !== null) slot.innerHTML = html;
    var btn = sectionHTML(state.sections['cart-notification-button'], '.shopify-section');
    if (btn !== null) setInner('cart-notification-button', btn.trim());
    setInner('cart-icon-bubble', sectionHTML(state.sections['cart-icon-bubble'], '.shopify-section'));
  }

  function loadNotice() {
    var slot = slotEl();
    if (!slot) return;
    fetch(root() + '?sections=kr-fraktskydd')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var html = sectionHTML(s['kr-fraktskydd'], '.shopify-section');
        if (html !== null) slot.innerHTML = html;
      })
      .catch(function () {});
  }

  function update(variantId, qty) {
    var page = onCartPage();
    var drawer = drawerEl();
    var body = { updates: {} };
    body.updates[variantId] = qty;
    if (!page) {
      body.sections = drawer
        ? ['cart-drawer', 'cart-icon-bubble']
        : ['kr-fraktskydd', 'cart-notification-button', 'cart-icon-bubble'];
    }
    return fetch(updateUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Fraktskydd: varukorgen kunde inte uppdateras');
        return r.json();
      })
      .then(function (state) {
        if (page) {
          window.location.reload();
          return state;
        }
        if (drawer) renderDrawer(state); else renderNotice(state);
        var ev = events();
        if (ev && typeof window.publish === 'function') {
          window.publish(ev.cartUpdate, { source: SOURCE, cartData: state });
        }
        return state;
      });
  }

  /* Reglaget */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || !input.classList || !input.classList.contains('kr-fs__input')) return;
    var box = input.closest('[data-kr-fs]');
    if (!box) return;
    var on = input.checked;
    box.classList.add('is-busy');
    box.classList.toggle('is-on', on);
    update(box.getAttribute('data-variant'), on ? 1 : 0)
      .catch(function (err) {
        console.error(err);
        input.checked = !on;
        box.classList.toggle('is-on', !on);
      })
      .finally(function () {
        box.classList.remove('is-busy');
      });
  });

  /* Fyll rutan varje gång "lagt i varukorgen" öppnas */
  function watchNotice() {
    var notif = document.getElementById('cart-notification');
    if (!notif || !window.MutationObserver) return;
    var wasActive = notif.classList.contains('active');
    new MutationObserver(function () {
      var active = notif.classList.contains('active');
      if (active && !wasActive) loadNotice();
      wasActive = active;
    }).observe(notif, { attributes: true, attributeFilter: ['class'] });
  }

  /* Städa: aldrig fler än ett fraktskydd, och inget fraktskydd i en annars tom korg */
  function tidy() {
    return fetch(((window.routes && window.routes.cart_url) || '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var fs = cart.items.filter(function (i) { return i.handle === HANDLE; });
        if (!fs.length) return;
        var qty = fs.reduce(function (a, i) { return a + i.quantity; }, 0);
        if (fs.length === cart.items.length) return update(fs[0].variant_id, 0);
        if (qty > 1) return update(fs[0].variant_id, 1);
      })
      .catch(function () {});
  }

  var ev = events();
  if (ev && typeof window.subscribe === 'function') {
    window.subscribe(ev.cartUpdate, function (event) {
      if (event && event.source === SOURCE) return;
      setTimeout(tidy, 300);
    });
  }

  function init() {
    watchNotice();
    if (onCartPage()) tidy();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
